export const TABLE_CACHE_INVALIDATE = 'tables/TABLE_CACHE_INVALIDATE'
